import axios from 'axios'

import { CamelToSnakeCaseNested, toSnakeCase } from '../lib/typeHelper'
import { Address } from './address'
import { Driver } from './driver'

export enum LineOfBusiness {
  TRUCKING = 'TRUCKING',
  CONTRACTOR = 'CONTRACTOR',
  OTHER = 'OTHER',
}

export interface Business {
  id: string
  dateCreated: string
  dateUpdated: string
  name: string
  dotNumber: string
  mcNumber: string
  caNumber: string
  // Carriers can exist with no address on file (the FK is nullable server-side).
  address: Address | null
  dateStarted: string
  yearsInBusiness: number | null
  drivers: Driver[]
  mcs150Mileage: number | null
  cargoCarried: string[] | null
  lineOfBusiness?: LineOfBusiness
  /** A contractor's trade (HVAC, PLUMBING, ...); blank for trucking. */
  trade?: string
  /** What a business outside the listed trades does, in the owner's words. */
  businessDescription?: string
}

/** How the console names a contractor's trade. */
export const TRADE_LABELS: Record<string, string> = {
  HVAC: 'HVAC',
  PLUMBING: 'Plumbing',
  ELECTRICAL: 'Electrical',
  LANDSCAPING: 'Landscaping',
  CONSTRUCTION: 'Construction',
  OTHER: 'Other',
}

/** The carrier on an org payload, which ships without the driver roster. */
export type OrgBusiness = Omit<Business, 'drivers'>

/** 0 is a first-year business, so only a missing value reads as "-". */
export function yearsInBusinessLabel(years: number | null | undefined): string {
  if (years === null || years === undefined) return '-'
  return `${years} ${years === 1 ? 'year' : 'years'}`
}

export interface UpdateBusinessData {
  name?: string
  dotNumber?: string
  mcNumber?: string
  caNumber?: string
  yearsInBusiness?: number | null
  address?: Partial<Omit<Address, 'id'>>
  entityType?: string
  eldProvider?: string
  cancellationReason?: string
}

export function updateBusiness(orgId: string, data: UpdateBusinessData) {
  return axios.patch(
    `/api/v1/insure/organisations/${orgId}/business/`,
    toSnakeCase(data as CamelToSnakeCaseNested<UpdateBusinessData>)
  )
}
